<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="优惠券类型" prop="type">
              <a-select
                default-value="1000"
                style="width: 120px"
                @change="handleChange"
                v-model="offer.type"
              >
                <!-- 2024/11/14 暂时隐藏, 因为功能还没完成 -->
                <!--<a-select-option value="1104"> 礼品券</a-select-option>-->
                <a-select-option value="1000"> 满减券</a-select-option>
                <a-select-option value="1105"> 代币券</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="标题" prop="title">
              <a-input v-model="offer.title" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询</a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <offerManagementHomeContent
          ref="aaa"
          :offer="offer"
        ></offerManagementHomeContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import offerManagementHomeContent from "./offerManagementHomeContent.vue";

export default {
  components: {
    offerManagementHomeContent,
  },
  data() {
    return {
      offer: {
        title: "",
        type: "",
        limit: 10,
        page: 1,
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.aaa.query();
    },
    resetForm() {
      this.$refs.aaa.getCouponsList();
      this.offer = {};
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/offerManagement/offerManagementHome.vue